module.exports = __webpack_public_path__ + "background2.b55a15da055091b06f6f.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/images/background2.jpg
// module id = ../../../../../src/app/images/background2.jpg
// module chunks = main